<div class="flex flex-wrap gap-4">
  <div class="flex shrink grow basis-96 flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm">
    <tasks-task-data-target (click)="navigateToMemberProfile()">
      <mat-icon icon>account_circle</mat-icon>
      <span text>{{ task.data.memberName }}</span>
    </tasks-task-data-target>
    <p>{{ task.data.memberPhoneNumber }}</p>
  </div>
  <div class="flex shrink grow basis-96 flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm">
    <div class="flex gap-2 text-lg">
      <mat-icon>corporate_fare</mat-icon>
      {{ task.data.partnerName }}
    </div>
    @if (task.data.partnerName !== task.data.locationName) {
      <p>{{ task.data.locationName }}</p>
    }
    <p>{{ task.data.locationAddress }}</p>
    @if (task.data.partnerPhoneNumbers.length) {
      <div class="flex flex-col gap-1">
        @for (phone of task.data.partnerPhoneNumbers; track phone) {
          <p>{{ phone }}</p>
        }
      </div>
    }
  </div>
  <div class="relative flex shrink grow basis-96 flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm">
    <tasks-task-data-target (click)="navigateToAppointment()">
      <mat-icon
        icon
        svgIcon="doctor"
      />
      <span text>{{ task.data.serviceName }}</span>
    </tasks-task-data-target>
    <p>{{ task.data.doctorName }}</p>
    @if (task.data.appointmentStartDate) {
      <p>{{ formatDate(task.data.appointmentStartDate, true) }}</p>
    }
  </div>
  <div class="relative flex shrink grow basis-96 flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm">
    <div class="flex items-center justify-between">
      @if (task.status !== taskStatus.Resolved) {
        <h4>{{ task.description }} {{ "task.message.updateAppointmentStatus" | translate }}</h4>
      } @else {
        <h4>{{ "task.message.appointmentStatusUpdated" | translate }}</h4>
      }
      @if (errorMessage(); as error) {
        <span class="text-sm text-error-500">{{ error | translate }}</span>
      }
    </div>

    @if (loadError()) {
      <div class="flex items-center gap-2">
        <span class="text-error-500">{{ "task.message.appointmentLoadError" | translate }}</span>
        <button
          class="cursor-pointer font-bold text-primary-500 hover:text-primary-600"
          type="button"
          (click)="loadVisit()"
        >
          {{ "packageConfigurator.action.retry" | translate }}
        </button>
      </div>
    } @else if (stateLabelKey(); as labelKey) {
      <span class="w-fit rounded-full bg-neutral-100 px-2 py-0.5 text-sm font-semibold text-neutral-700">{{ labelKey | translate }}</span>
    }

    @if (task.status !== taskStatus.Resolved && !loading() && !loadError()) {
      @if (canEndFulfillment()) {
        <div class="flex justify-end">
          <button
            class="btn btn-primary"
            type="button"
            [disabled]="saving()"
            (click)="endFulfillment()"
          >
            {{ "guaranteeV2.action.endFulfillment" | translate }}
          </button>
        </div>
      } @else {
        <p class="text-sm text-neutral-500">{{ "task.message.appointmentNoLongerOpen" | translate }}</p>
      }
    }

    @if (loading() || saving()) {
      <div class="absolute inset-0 z-10 flex items-center justify-center rounded-lg bg-neutral-0/80">
        <shared-loader />
      </div>
    }
  </div>
</div>
